// Типы для статистики программы Сейф

export interface SafeProgramStatistics {
    program_id: number;
    program_name: string;
    program_type: string;
    total_amount: string;
    total_dividends_to_pay: string;
}

export interface SafeStatistics {
    total_all_users: number;
    total_users_with_safe_programs: number;
    total_users: number;
    total_money_safe: string;
    total_money_safe_work: string;
    programs_statistics: SafeProgramStatistics[];
}

export interface SafeUser {
    id: number;
    ref_link: string;
    name: string;
    surname: string;
    email: string;
    telegram_id: string | null;
    safe_price_group: string | null;
    money_safe: string;
    money_safe_work: string;
    active_programs_count: number;
}

export interface SafeUserDetails {
    user: {
        id: number;
        name: string;
        surname: string;
        email: string;
        ref_link: string;
        safe_price_group: string | null;
        money_safe: string;
        money_safe_work: string;
    };
    programs: SafeProgramDetails[];
}

export interface SafeProgramActivationDetails {
    id: number;
    price: string;
    activated_at: string | null;
    deactivated_at: string | null;
}

export interface SafeProgramDetails {
    id: number;
    program: {
        id: number;
        name: string;
        type: string;
        safe_dividend_percent: string;
        safe_payment_interval: number;
    };
    amount: string;
    is_active: number;
    is_program_active: boolean;
    last_payment_at: string | null;
    created_at: string | null;
    oferta_signed_at: string | null;
    activation_price: number;
    dividend_amount: string;
    next_payment_at: string | null;
    structural_topup_paid: boolean;
    activations: SafeProgramActivationDetails[];
}

export interface SafeUsersResponse {
    users: SafeUser[];
    pagination: {
        current_page: number;
        last_page: number;
        per_page: number;
        total: number;
        from: number | null;
        to: number | null;
    };
}

export interface SafeUsersRequest {
    page?: number;
    per_page?: number;
    sort_by?: string;
    sort_order?: "asc" | "desc";
    search?: string;
    program_id?: number;
    structural_topup_paid?: boolean;
}

export const safeEndpoints = {
    getAdminSafeStatistics: {
        query: () => "/admin/safe/statistics",
        providesTags: ["safe-statistics"],
    },

    getAdminSafeUsers: {
        query: (params: SafeUsersRequest = {}) => ({
            url: "/admin/safe/users",
            params,
        }),
        providesTags: ["safe-users"],
    },

    getAdminSafeUserDetails: {
        query: (userId: number) => `/admin/safe/users/${userId}`,
        providesTags: (_result: any, _error: any, userId: number) => [
            { type: "safe-user-details", id: userId },
        ],
    },

    updateStructuralTopupPaid: {
        query: ({
            userId,
            programId,
            paid,
        }: {
            userId: number;
            programId: number;
            paid: boolean;
        }) => ({
            url: `/admin/safe/users/${userId}/programs/${programId}/structural-topup`,
            method: "PUT",
            body: { structural_topup_paid: paid },
        }),
        invalidatesTags: (_result: any, _error: any, { userId }: { userId: number }) => [
            { type: "safe-user-details", id: userId },
        ],
    },
};

export const safeTags = ["safe-statistics", "safe-users", "safe-user-details"];
